export default {
  'Screenshot': 'Schermafbeelding',
}